<template>
	<div class="appointment-navigation btn-group-navigation">
		<router-link :to="{ name: 'WatchAppointmentAll', params: { user_uid: user_uid, watch_id: watch_id } }">{{ $t('buttons.general.all') }}</router-link>
		<router-link :to="{ name: 'WatchAppointmentUpcoming', params: { user_uid: user_uid, watch_id: watch_id } }">{{ $t('buttons.general.upcoming') }}</router-link>
		<router-link :to="{ name: 'WatchAppointmentCalendar', params: { user_uid: user_uid, watch_id: watch_id } }">{{ $t('buttons.general.calendar') }}</router-link>
		<router-link :to="{ name: 'WatchAppointmentDayView', params: { user_uid: user_uid, watch_id: watch_id } }">{{ $t('buttons.general.by_day') }}</router-link>
	</div>
</template>

<script>
export default {
	props: [
		'user_uid',
		'watch_id'
	]
}
</script>



// WEBPACK FOOTER //
// src/components/watch/appointments/AppointmentNavigation.vue